// extracted by mini-css-extract-plugin
export default {"categoryTilesPanel":"CategoryTilesPanel__categoryTilesPanel--P4","categoryTilesContainer":"CategoryTilesPanel__categoryTilesContainer--Zz"};